import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import 'antd/dist/reset.css';
import App from './App.jsx'
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './Context/AuthContext';
import { DomainGroupsProvider } from './Context/DomainGroupsContext';
import { GoogleOAuthProvider } from '@react-oauth/google';

const clientId = '188982591536-mgi8jrabhufuc4jk94mpo9nd8mefak7u.apps.googleusercontent.com';

createRoot(document.getElementById('root')).render(
  <AuthProvider>
    <DomainGroupsProvider>
      <Router>
        <GoogleOAuthProvider clientId={clientId}>
          <StrictMode>
            <App />
          </StrictMode>
        </GoogleOAuthProvider>
      </Router>
    </DomainGroupsProvider>
  </AuthProvider>,
)
